import React from 'react';
import { IIconProps } from '../IIconProps';

export const ModalDoneIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			viewBox="0 0 56 46"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={iconClass}
		>
			{title && <title>{title}</title>}
			<path d="M36 17L25 28L20 23" stroke="#2C3171" />
			<path
				d="M40.7279 10.2721C37.3523 6.89642 32.7739 5 28 5C23.2261 5 18.6477 6.89642 15.2721 10.2721C11.8964 13.6477 10 18.2261 10 23C10 27.7739 11.8964 32.3523 15.2721 35.7279C18.6477 39.1036 23.2261 41 28 41C32.7739 41 37.3523 39.1036 40.7279 35.7279C44.1036 32.3523 46 27.7739 46 23C46 18.2261 44.1036 13.6477 40.7279 10.2721Z"
				stroke="#2C3171"
			/>
		</svg>
	);
};
